import React from 'react';

function RoundAwarenessTitle () {
    return(
        <div>
            <h1 className="GuideTitle">Round Awareness</h1>
            <h2 className="GuideTitleH2">Written By: David "Gatr" Macaulay</h2>
        </div>
    )
}

export default RoundAwarenessTitle;